<template>
    <div
        v-if="!hasLoading && ( $route.meta.isAdd || model )"
        class="client"
    >
        <base-form class="client__form display--grid">
            <base-card
                class="card--identification"
            >
                <template #card__title >
                    <span class="capitalize display--block">
                        {{ $t(`global.identification`) }}
                    </span>
                </template>
                <template #card__body >
                    <div class="client__body card--identification__body display--grid">
                        <base-field
                            class="client__body__number"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.associateNumber') },
                                input: {
                                    component: 'InputBasic',
                                    id: 'number',
                                    name: 'number',
                                    type: 'text',
                                    class: 'field__input--default typography--default color--default',
                                    value: model.number,
                                    browserAutocomplete: 'off',
                                    isRequired: $route.meta.isAdd,
                                    isMissing: errors.missing.number,
                                    fileValidation: 'numberInt',
                                    errors: [{
                                        type: 'integer', warning: $t('error.integer')
                                    }],
                                    errorOnSubmit: {
                                        show: errors.api.number ? true : false,
                                        messages: errors.api.number
                                    }
                                },
                                isEdition,
                                reset,
                                allowFilling: true
                            }"
                        />

                        <base-field
                            class="client__body__type"
                            :settings="{
                                label: { class: 'capitalize', text: $t('global.associateType') },
                                input: {
                                    component: 'InputAutocomplete',
                                    name: 'type',
                                    id: 'type',
                                    type: 'text',
                                    value: `${types.api.id}`,
                                    targetClass: 'import__filters__districts field__input--default typography--default color--default',
                                    browserAutocomplete: 'off',
                                    placeholder: $t('global.selectAnOption'),
                                    isRequired: $route.meta.isAdd,
                                    isMissing: errors.missing.type,
                                    dynamicData: {
                                        data: types.drop,
                                        apiValue: { value: `${types.api.id}`, label: types.api.name }
                                    },
                                    noListener: true
                                },
                                isEdition,
                                reset,
                                allowFilling: true
                            }"
                        />
                        <base-button
                            @click.prevent.native="modals.deleteAssociate.actions.open( 'deleteAssociate' )"
                            class="client__body__delete-associate"
                            v-html="$t(`global.deleteAssociate`)"
                        />
                    </div>
                </template>
            </base-card>
            <div class="client__form__left-column">
                <base-card
                    class="card--personal-information"
                >
                    <template #card__title >
                        <span class="capitalize display--block">
                            {{ $t(`global.personalInformation`) }}
                        </span>
                    </template>
                    <template #card__body >
                        <div class="client__body display--grid">
                            <base-field
                                class="client__body__honorific-prefix"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.honorificPrefix') },
                                    input: {
                                        component: 'InputBasic',
                                        id: 'prefix',
                                        name: 'prefix',
                                        type: 'text',
                                        class: 'field__input--default typography--default color--default',
                                        value: model.prefix,
                                        browserAutocomplete: 'off',
                                        isRequired: $route.meta.isAdd,
                                        isMissing: errors.missing.prefix,
                                        errorOnSubmit: {
                                            show: errors.api.prefix ? true : false,
                                            messages: errors.api.prefix
                                        }
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling: true
                                }"
                            />
                            <base-field
                                class="client__body__name"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.name') },
                                    input: {
                                        component: 'InputBasic',
                                        id: 'name',
                                        name: 'name',
                                        type: 'text',
                                        class: 'field__input--default typography--default color--default',
                                        value: model.name,
                                        browserAutocomplete: 'off',
                                        isRequired: $route.meta.isAdd,
                                        isMissing: errors.missing.name,
                                        errorOnSubmit: {
                                            show: errors.api.name ? true : false,
                                            messages: errors.api.name
                                        }
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling: true
                                }"
                            />
                            <base-field
                                class="client__body__simple-name"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.simpleName') },
                                    input: {
                                        component: 'InputBasic',
                                        id: 'simpleName',
                                        name: 'simpleName',
                                        type: 'text',
                                        class: 'field__input--default typography--default color--default',
                                        value: model.simpleName,
                                        browserAutocomplete: 'off',
                                        isRequired: false,
                                        isMissing: errors.missing.simpleName,
                                        errorOnSubmit: {
                                            show: errors.api.simpleName ? true : false,
                                            messages: errors.api.simpleName
                                        }
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling: true
                                }"
                            />
                            <base-field
                                class="client__body__address"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.address') },
                                    input: {
                                        component: 'InputBasic',
                                        id: 'address',
                                        name: 'address',
                                        type: 'text',
                                        class: 'field__input--default typography--default color--default',
                                        value: model.address,
                                        browserAutocomplete: 'off',
                                        isRequired: $route.meta.isAdd,
                                        isMissing: errors.missing.address,
                                        errorOnSubmit: {
                                            show: errors.api.address ? true : false,
                                            messages: errors.api.address
                                        }
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling: true
                                }"
                            />
                            <base-field
                                class="client__body__zip-code"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.zipCode') },
                                    input: {
                                        component: 'InputBasic',
                                        name: 'zipCode',
                                        id: 'zipCode',
                                        type: 'text',
                                        mask: isForeignRegion ? '' : '####-###',
                                        value: model.zipCode,
                                        class: 'field__input--default typography--default color--default',
                                        browserAutocomplete: 'off',
                                        isRequired: $route.meta.isAdd,
                                        isMissing: errors.missing.zipCode,
                                        errorOnSubmit: {
                                            show: errors.api.zipCode ? true : false,
                                            messages: errors.api.zipCode
                                        },
                                        placeholder: 'Ex: 0000-000',
                                        noListener: true
                                    },
                                    allowFilling: true
                                }"
                            />
                            <base-field
                                class="client__body__region"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.region') },
                                    input: {
                                        component: 'InputAutocomplete',
                                        name: 'region',
                                        id: 'region',
                                        type: 'text',
                                        value: model.region,
                                        targetClass: 'import__filters__districts field__input--default typography--default color--default',
                                        browserAutocomplete: 'off',
                                        placeholder: $t('global.selectAnOption'),
                                        isRequired: $route.meta.isAdd,
                                        isMissing: errors.missing.region,
                                        dynamicData: {
                                            data: regions.drop,
                                            apiValue: { value: model.region, label: model.region }
                                        },
                                        noListener: true
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling: true
                                }"
                            />
                            <base-field
                                class="client__body__country"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.country') },
                                    input: {
                                        component: 'InputAutocomplete',
                                        name: 'country',
                                        id: 'country',
                                        type: 'text',
                                        value: `${countries.api.id}`,
                                        targetClass: 'import__filters__districts field__input--default typography--default color--default',
                                        browserAutocomplete: 'off',
                                        placeholder: $t('global.selectAnOption'),
                                        isRequired: $route.meta.isAdd,
                                        isMissing: errors.missing.country,
                                        dynamicData: {
                                            data: countries.drop,
                                            apiValue: { value: `${countries.api.id}`, label: countries.api.name }
                                        },
                                        noListener: true
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling: true
                                }"
                            />
                        </div>
                    </template>
                </base-card>
                <base-card
                    class="card--payment-information"
                >
                    <template #card__title >
                        <span class="capitalize display--block">
                            {{ $t(`global.paymentInformation`) }}
                        </span>
                    </template>
                    <template #card__body >
                        <div class="display--grid">
                            <base-field
                                class="client__body__nif"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.nif') },
                                    input: {
                                        component: 'InputBasic',
                                        id: 'nif',
                                        name: 'nif',
                                        type: 'text',
                                        class: 'field__input--default typography--default color--default',
                                        value: model.nif,
                                        browserAutocomplete: 'off',
                                        isRequired: $route.meta.isAdd,
                                        isMissing: errors.missing.nif,
                                        errorOnSubmit: {
                                            show: errors.api.nif ? true : false,
                                            messages: errors.api.nif
                                        }
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling: true
                                }"
                            />
                            <base-field
                                class="client__body__payment-method"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.paymentMethod') },
                                    input: {
                                        component: 'InputAutocomplete',
                                        name: 'paymentMethod',
                                        id: 'paymentMethod',
                                        type: 'text',
                                        value: model.paymentMethod,
                                        targetClass: 'import__filters__districts field__input--default typography--default color--default',
                                        browserAutocomplete: 'off',
                                        placeholder: $t('global.selectAnOption'),
                                        isRequired: $route.meta.isAdd,
                                        isMissing: errors.missing.paymentMethod,
                                        dynamicData: {
                                            data: paymentMethods.drop,
                                            apiValue: { value: model.paymentMethod, label: model.paymentMethod }
                                        },
                                        noListener: true
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling: true
                                }"
                            />
                        </div>
                    </template>
                </base-card>
                <base-card
                    v-if="!$route.meta.isAdd"
                    class="card--quotas"
                >
                    <template #card__title >
                        <span class="capitalize display--block">
                            {{ $t(`global.payedQuotas`) }}
                        </span>
                    </template>
                    <template #card__body >
                        <div class="display--grid">
                            <div class="table--quotas">
                                <div class="table--quotas__header display--flex">
                                    <div class="table--quotas__header__year capitalize">{{ $t('global.year') }}</div>
                                    <div class="table--quotas__header__value capitalize">{{ $t('global.value') }}</div>
                                    <div class="table--quotas__header__invoice capitalize">{{ $t('global.invoice') }}</div>
                                    <div class="table--quotas__header__date capitalize">{{ $t('global.date') }}</div>
                                    <div class="table--quotas__header__payed capitalize">{{ $t('global.payed') }}</div>
                                </div>
                                <div class="table--quotas__body">
                                    <div
                                        v-for="( fee, index ) in model.fees"
                                        :key="`fee-${index}`"
                                        class="table--quotas__body__row display--flex"
                                    >
                                        <div class="table--quotas__body__row__year">{{ fee.year || '---' }}</div>
                                        <div class="table--quotas__body__row__value">{{ fee.value || '---' }}</div>
                                        <div class="table--quotas__body__row__invoice">
                                            <base-field
                                                class="client__body__invoice-number"
                                                :settings="{
                                                    label: { class: 'field__label--hide' },
                                                    input: {
                                                        component: 'InputBasic',
                                                        id: `invoiceNumber-${fee.id}`,
                                                        name: `invoiceNumber-${fee.id}`,
                                                        type: 'text',
                                                        class: 'field__input--default typography--default color--default',
                                                        value: ( fee.invoiceNumber ) ? fee.invoiceNumber.toString() : '',
                                                        placeholder: $t('global.invoiceNumber'),
                                                        browserAutocomplete: 'off',
                                                        isRequired: false,
                                                        isMissing: errors.missing[`invoiceNumber-${fee.id}`],
                                                        errorOnSubmit: {
                                                            show: errors.api[`invoiceNumber-${fee.id}`] ? true : false,
                                                            messages: errors.api[`invoiceNumber-${fee.id}`]
                                                        }
                                                    },
                                                    isEdition,
                                                    reset,
                                                    allowFilling: true
                                                }"
                                            />
                                        </div>
                                        <div class="table--quotas__body__row__date">{{ fee.paymentDate || '---' }}</div>
                                        <div class="table--quotas__body__row__payed">
                                            <base-field
                                                class="client__body__invoice-number"
                                                :settings="{
                                                    input: {
                                                        component: 'InputCheckbox',
                                                        id: `payed-${fee.id}`,
                                                        name: `payed-${fee.id}`,
                                                        type: 'checkbox',
                                                        class: 'field__input--checkbox',
                                                        value: fee.paymentDate !== null,
                                                        browserAutocomplete: 'off',
                                                        isRequired: false,
                                                        isMissing: errors.missing[`payed-${fee.id}`],
                                                        errorOnSubmit: {
                                                            show: errors.api[`payed-${fee.id}`] ? true : false,
                                                            messages: errors.api[`payed-${fee.id}`]
                                                        }
                                                    },
                                                    isEdition,
                                                    reset,
                                                    allowFilling: true
                                                }"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </base-card>
            </div>
            <div class="client__form__right-column display--grid">
                <base-card
                    class="card--professional-information"
                >
                    <template #card__title >
                        <span class="capitalize display--block">
                            {{ $t(`global.professionalInformation`) }}
                        </span>
                    </template>
                    <template #card__body >
                        <div class="display--grid">
                            <base-field
                                class="client__body__profession"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.profession') },
                                    input: {
                                        component: 'InputBasic',
                                        id: 'profession',
                                        name: 'profession',
                                        type: 'text',
                                        class: 'field__input--default typography--default color--default',
                                        value: model.profession,
                                        browserAutocomplete: 'off',
                                        isRequired: $route.meta.isAdd,
                                        isMissing: errors.missing.profession,
                                        errorOnSubmit: {
                                            show: errors.api.profession ? true : false,
                                            messages: errors.api.profession
                                        }
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling: true
                                }"
                            />
                            <base-field
                                class="client__body__role"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.professionalPosition') },
                                    input: {
                                        component: 'InputBasic',
                                        id: 'role',
                                        name: 'role',
                                        type: 'text',
                                        class: 'field__input--default typography--default color--default',
                                        value: model.role,
                                        browserAutocomplete: 'off',
                                        isRequired: $route.meta.isAdd,
                                        isMissing: errors.missing.role,
                                        errorOnSubmit: {
                                            show: errors.api.role ? true : false,
                                            messages: errors.api.role
                                        }
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling: true
                                }"
                            />
                            <base-field
                                class="client__body__organization"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.organization') },
                                    input: {
                                        component: 'InputBasic',
                                        id: 'organization',
                                        name: 'organization',
                                        type: 'text',
                                        class: 'field__input--default typography--default color--default',
                                        value: model.organization,
                                        browserAutocomplete: 'off',
                                        isRequired: $route.meta.isAdd,
                                        isMissing: errors.missing.organization,
                                        errorOnSubmit: {
                                            show: errors.api.organization ? true : false,
                                            messages: errors.api.organization
                                        }
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling: true
                                }"
                            />
                        </div>
                    </template>
                </base-card>
                <base-card
                    class="card--contact-information"
                >
                    <template #card__title >
                        <span class="capitalize display--block">
                            {{ $t(`global.contactInformation`) }}
                        </span>
                    </template>
                    <template #card__body >
                        <div class="client__body display--grid">
                            <base-field
                                class="client__body__email"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.email') },
                                    input: {
                                        component: 'InputBasic',
                                        id: 'email',
                                        name: 'email',
                                        type: 'text',
                                        class: 'field__input--default typography--default color--default',
                                        value: model.email,
                                        browserAutocomplete: 'email',
                                        isRequired: $route.meta.isAdd,
                                        isMissing: errors.missing.email,
                                        fileValidation: 'basicEmail',
                                        errors: [{
                                            type: 'email', warning: $t('error.email')
                                        }],
                                        errorOnSubmit: {
                                            show: errors.api.email ? true : false,
                                            messages: errors.api.email
                                        }
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling: true
                                }"
                            />
                            <base-field
                                class="client__body__telephone"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.telephone') },
                                    input: {
                                        component: 'InputBasic',
                                        id: 'secondaryPhone',
                                        name: 'secondaryPhone',
                                        type: 'text',
                                        class: 'field__input--default typography--default color--default',
                                        value: model.secondaryPhone,
                                        browserAutocomplete: 'secondaryPhone',
                                        isRequired: false,
                                        isMissing: errors.missing.secondaryPhone,
                                        errorOnSubmit: {
                                            show: errors.api.secondaryPhone ? true : false,
                                            messages: errors.api.secondaryPhone
                                        }
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling: true
                                }"
                            />
                            <base-field
                                class="client__body__mobile-phone"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.mobilePhone') },
                                    input: {
                                        component: 'InputBasic',
                                        id: 'primaryPhone',
                                        name: 'primaryPhone',
                                        type: 'text',
                                        class: 'field__input--default typography--default color--default',
                                        value: model.primaryPhone,
                                        browserAutocomplete: 'primaryPhone',
                                        isRequired: false,
                                        isMissing: errors.missing.primaryPhone,
                                        errorOnSubmit: {
                                            show: errors.api.primaryPhone ? true : false,
                                            messages: errors.api.primaryPhone
                                        }
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling: true
                                }"
                            />
                            <base-field
                                class="client__body__fax"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.fax') },
                                    input: {
                                        component: 'InputBasic',
                                        id: 'fax',
                                        name: 'fax',
                                        type: 'text',
                                        class: 'field__input--default typography--default color--default',
                                        value: model.fax,
                                        browserAutocomplete: 'fax',
                                        isRequired: false,
                                        isMissing: errors.missing.fax,
                                        errorOnSubmit: {
                                            show: errors.api.fax ? true : false,
                                            messages: errors.api.fax
                                        }
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling: true
                                }"
                            />
                        </div>
                    </template>
                </base-card>
                <base-card
                    class="card--other-informations"
                >
                    <template #card__title >
                        <span class="capitalize display--block">
                            {{ $t(`global.otherInformations`) }}
                        </span>
                    </template>
                    <template #card__body >
                        <div class="display--grid">
                            <base-field
                                class="client__body__admission-date"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.admittedOn') },
                                    input: {
                                        component: 'InputCalendar',
                                        name: 'admissionDate',
                                        id: 'admissionDate',
                                        targetClass: 'field__input--default typography--default color--default',
                                        value: model.admissionDate,
                                        browserAutocomplete: 'off',
                                        isRequired: $route.meta.isAdd,
                                        isMissing: errors.missing.admissionDate,
                                        errorOnSubmit: {
                                            show: errors.api.admissionDate ? true : false,
                                            messages: errors.api.admissionDate
                                        },
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling: permissions.allowFilling
                                }"
                            />
                            <base-field
                                class="client__body__readmission-date"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.readmittedOn') },
                                    input: {
                                        component: 'InputCalendar',
                                        name: 'readmissionDate',
                                        id: 'readmissionDate',
                                        targetClass: 'field__input--default typography--default color--default',
                                        value: model.readmissionDate,
                                        browserAutocomplete: 'off',
                                        isRequired: false,
                                        isMissing: errors.missing.readmissionDate,
                                        errorOnSubmit: {
                                            show: errors.api.readmissionDate ? true : false,
                                            messages: errors.api.readmissionDate
                                        },
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling: permissions.allowFilling
                                }"
                            />
                            <base-field
                                class="client__body__leaving-date"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.leavingOn') },
                                    input: {
                                        component: 'InputCalendar',
                                        name: 'leavingDate',
                                        id: 'leavingDate',
                                        targetClass: 'field__input--default typography--default color--default',
                                        value: model.leavingDate,
                                        browserAutocomplete: 'off',
                                        isRequired: false,
                                        isMissing: errors.missing.leavingDate,
                                        errorOnSubmit: {
                                            show: errors.api.leavingDate ? true : false,
                                            messages: errors.api.leavingDate
                                        },
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling: permissions.allowFilling
                                }"
                            />
                            <base-field
                                class="client__body__leaving-reason"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.leavingReason') },
                                    input: {
                                        component: 'InputAutocomplete',
                                        name: 'leavingReason',
                                        id: 'leavingReason',
                                        type: 'text',
                                        value: model.leavingReason,
                                        targetClass: 'import__filters__districts field__input--default typography--default color--default',
                                        browserAutocomplete: 'off',
                                        placeholder: $t('global.selectAnOption'),
                                        dynamicData: {
                                            data: leavingReasons.drop,
                                            apiValue: { value: model.leavingReason, label: model.leavingReason }
                                        },
                                        noListener: true
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling: true
                                }"
                            />
                            <base-field
                                :class="'client__body__observations'"
                                :settings="{
                                    label: { class: 'capitalize', text: $t('global.observations') },
                                    input: {
                                        component: 'Textarea',
                                        name: 'observations',
                                        id: 'observations',
                                        class: 'client__body__observations__field typography--default color--default',
                                        value: model.observations || '',
                                        placeholder: $t('global.observations'),
                                        disableClass: 'client__body__observations__field client__body__observations__field--disable display--block'
                                    },
                                    isEdition,
                                    reset,
                                    allowFilling: permissions.allowFilling
                                }"
                            />
                        </div>
                    </template>
                </base-card>
                <div class="client__body__actions display--grid">
                    <submission-handler v-if="getters.payloadHaveKeys">
                        <base-button
                            type="submit"
                            class="client__body__actions__save background--blue color--white display--block"
                            v-html="$t('global.save')"
                        />
                    </submission-handler>

                    <base-button
                        v-if="getters.payloadHaveKeys"
                        class="client__body__actions__cancel background--transparent color--blue"
                        @click="cancelSubmission"
                        v-html="$t('global.cancel')"
                    />
                </div>
            </div>
        </base-form>
        <!-- modal de confirmação para forçar o update do guião -->
        <modal
            v-if="modals.deleteAssociate.show"
            :form="{
                class: 'modal__confirmation--delete-associate'
            }"
            :customSettings="{
                position: 'center',
                button: {
                    label: 'remove',
                    type: 'button',
                    action: () => modals.deleteAssociate.actions.submit()
                }
            }"
            @close="modals.deleteAssociate.actions.close( 'deleteAssociate' )"
            :key="modals.deleteAssociate.show"
        >
            <template #modal__header >
                <h2 class="modal__confirmation--delete-associate__header">{{ $t('global.deleteAssociate') }}</h2>
            </template>
            <template #modal__body__confirm >
                <span class="modal__confirmation--delete-associate__info display--block capitalize">
                    {{ $t('global.areYouSureYouWantTo') + $t('warning.deleteThisAssociate') + ' ?'}}
                </span>
            </template>
            <template #modal__info >
                <base-button
                    class="modal__content__button--negative background--transparent border--grey"
                    @click.prevent="modals.deleteAssociate.actions.close( 'deleteAssociate' )"
                    v-html="$t('global.cancel')"
                />
            </template>
        </modal>
    </div>
</template>

<script>
// packages
import { reactive, toRefs, computed } from '@vue/composition-api';

// hooks
import { singleStructure, useData } from '@/hooks/use-data';

// store
// eslint-disable-next-line
import { storePayload, mapState, useStore } from '@/hooks/use-store';

// consts
import {
    associateTypes,
    leavingReasons,
    regions,
    paymentMethods,
    countriesList
} from '@/configs/const';

// i18n
import i18n from '@/plugins/i18n';

// requests
// eslint-disable-next-line
import { deleteRequest } from '@/helpers/requests';

export default {
    components: {
        ...singleStructure.components,
        SubmissionHandler: () => import(
            /* webpackChunkName: 'SubmissionHandler' */
            '@/components/bundles/layout/SubmissionHandler/SubmissionHandler'
        ),
        Modal: () => import( /* webpackChunkName: 'Modal' */ '@/components/bundles/layout/modals/Modal' )
    },
    props: {
        ...singleStructure.props
    },
    setup ( props, { root: { $route, $router } }) {
        const { getters, actions } = useStore();

        // obtenção da store errors & reset
        const { errors, reset } = storePayload();

        // obtenção do payload
        const payload = mapState({ module: 'storePayload', key: 'payload' });

        const state = reactive({
            types: {
                api: {},
                drop: Object.keys( associateTypes ).map( key => ({ value: key, label: i18n.t( `associateTypes.${associateTypes[key]}` ) }) )
            },
            paymentMethods: {
                api: {},
                drop: paymentMethods.map( key => ({ value: key, label: key }) )
            },
            leavingReasons: {
                api: {},
                drop: leavingReasons.map( key => ({ value: key, label: key }) )
            },
            regions: {
                api: {},
                drop: regions.map( key => ({ value: key, label: key }) )
            },
            countries: {
                api: {},
                drop: countriesList.map( country => ({ value: country.id, label: country.name }) )
            }
        });

        // validação se a região é 'estrangeiro'.
        const isForeignRegion = computed( () => props.model?.region === 'Estrangeiro' || payload.value?.region === 'Estrangeiro' );

        // o utilizador cancelou a submissão.
        // é fechado a barra de acção e dado clear
        // ao payload.
        const cancelSubmission = () => {
            ( $route.meta.isAdd )
                ? $router.go( -1 ) // vai para a página anterior
                : actions( 'resetModel' );
        };

        const structureData = newModel => {
            // se não exister novo model,
            // não é necessário executar o resto do código.
            if ( !Object.keys( newModel ).length )
                return;

            state.types.api = { id: newModel.type.id, name: i18n.t( `associateTypes.${associateTypes[newModel.type.id]}` ) };
            state.countries.api = { id: newModel?.countryId, name: newModel?.country };
        };

        useData( props, structureData );

        // Fecho do modal.
        const closeModal = modalName => {
            modals[modalName].show = false;
        };

        // Abertura do modal.
        const openModal = modalName => {
            modals[modalName].show = true;
        };

        // Remoção do associado.
        const deleteAssociate = async () => {
            const endpoint = modals.deleteAssociate.settings.url;

            actions( 'toggleLoading' );
            const response = await deleteRequest( endpoint, {
                data: {
                    id: modals.deleteAssociate.settings.id
                }
            })
                .then( ({ data }) => ({
                    has: true,
                    type: 'success',
                    message: data.message,
                    content: data?.content?.data
                }) )
                .catch( error => ({
                    has: true,
                    type: 'insuccess',
                    message: error.message,
                    errors: error?.content?.errors || i18n.t( 'error.request' )
                }) );

            // procedimento no final da submissão.
            actions( 'finalSubmission', response );

            // Fechar Modal.
            closeModal( 'deleteAssociate' );

            // Redirecionar para a página do cliente.
            $router.push({ name: 'clients' });
        };

        const modals = reactive({
            deleteAssociate: {
                show: false,
                actions: {
                    close: closeModal,
                    open: openModal,
                    submit: deleteAssociate
                },
                settings: {
                    url: '/clients',
                    id: $route.params.id
                }
            }
        });

        return {
            ...toRefs( state ),
            modals,
            errors,
            reset,
            cancelSubmission,
            getters,
            isForeignRegion,
            deleteAssociate
        };
    }
};
</script>

<style lang="scss" scoped>
    .client {
        max-width: 1120px;
        margin: 0 auto;
        @include responsive( max-width, 1200px ) {
           margin: 0 45px;
        }
        &__form {
            grid-gap: 30px;
            grid-template: auto / repeat( 2, 1fr );
        }
        &__body {
            grid-template: auto / repeat( 2, 1fr );
            &__email, &__honorific-prefix, &__name, &__simple-name, &__address {
                grid-column: 1 / -1;
            }
            &__number {
                grid-column: 1 / 3;;
            }
            &__actions {
                grid-template: auto / repeat( 2, 1fr );
            }
            &__delete-associate {
                @include dimensions( 100%, 50px );
                @include rounded-corner( 5px );
                @include elements-colors( #FFEFEF, #FF4D4D );
            }
        }
    }
    .card {
        &--identification {
            &__body {
                grid-template: auto/ repeat( 4, 1fr );
                align-items: center;
            }
        }

    }
    .table--quotas {
        &__header, &__body__row {
            justify-content: space-between;
            gap: 5px;
            &__year, &__value {
                width: 15%;
            }
            &__invoice, &__date {
                width: 27%;
            }
            &__payed {
                width: 16%;
            }
        }
        &__header {
            font-weight: 400;
            margin-bottom: 22px;
        }
        &__body__row {
            align-items: center;
        }
        &__body__row:not( :last-child ) {
            margin-bottom: 13px;
        }
    }
</style>